import { useRef, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@/components/layout/Container';
import { Section } from '@/components/layout/Section';
import { Button } from '@/components/primitives/Button';
import { useFadeUpOnScroll } from '@/hooks/useFadeUpOnScroll';
import { CONTACT_SALES_EMAIL, CONTACT_SALES_EMAIL_HREF } from '@/lib/contact';
import styles from './BottomCtaSection.module.css';

export const BottomCtaSection: FC = () => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  useFadeUpOnScroll(ref, { selector: '[data-fade]', stagger: 0.12 });

  return (
    <Section tone="muted" id="cta" spacing="default">
      <Container size="default">
        <div ref={ref} className={styles.inner}>
          <h2 className={styles.title} data-fade>
            {t('home.cta.title')}
          </h2>
          <p className={styles.body} data-fade>
            {t('home.cta.body')}
          </p>
          <div className={styles.actions} data-fade>
            <Button as="link" to="/login" size="lg" variant="primary">
              {t('home.cta.primaryCta')}
            </Button>
          </div>
          <a className={styles.contactLink} href={CONTACT_SALES_EMAIL_HREF} data-fade>
            {CONTACT_SALES_EMAIL}
          </a>
        </div>
      </Container>
    </Section>
  );
};

BottomCtaSection.displayName = 'BottomCtaSection';
